import {
  Platform,
  Share,
  ShareContent,
  ShareOptions,
} from 'react-native';
import copy from 'copy-to-clipboard';

import ToastService from './ToastService';
import { IS_WEB } from '@utils';

interface IShareOptions extends ShareOptions {
  clipboardMessage?: string;
}

interface IShareUrlParams {
  url: string;
}

class ShareService {
  async share(content: ShareContent, options?: IShareOptions) {
    try {
      if (IS_WEB && typeof content.message === 'string') {
        copy(content.message, { format: 'text/plain' });

        if (options?.clipboardMessage) {
          ToastService.showSuccess(options.clipboardMessage);
        }

        return;
      }

      await Share.share(content, options);
    } catch (error) {
      throw error;
    }
  }

  async shareUrl(params: IShareUrlParams, options?: IShareOptions) {
    await this.share(
      Platform.select({
        ios: { url: params.url },
        default: { message: params.url },
      }),
      options,
    );
  }
}

export default new ShareService();
